/**
 * Optional features available in the Visitors Area widget.
 */
export enum WidgetFunctionality {
  whatsAppChat = 'visitors-area-widget-chat-whatsApp',
  facebookMessengerChat = 'visitors-area-widget-chat-messenger',
  fullPotential = 'visitors-area-widget-full-potential',
  chat = 'visitors-area-widget-chat',
  aiAssistant = 'visitors-area-widget-ai-assistant',
}
